<template>
  <div class="ui-box-item">
    <titleComponents :show.sync="show" name="基础信息"></titleComponents>
    <div class="itemInfo-detail" v-show="show">
      <table class="ui-box-table">
        <tr>
          <td style="width:12%">姓名</td>
          <td style="width:19%">{{data.username||''}}</td>
          <td style="width:12%">国籍</td>
          <td style="width:19%">{{data.tbNationality&&nationalityList[data.tbNationality - 1]||'-'}}</td>
          <td style="width:12%">职业</td>
          <td style="width:26%">{{data.tbOccupationType&&occupationTypeList[data.tbOccupationType - 1]||'-'}}</td>
        </tr>
        <tr>
          <td style="width:12%">昵称</td>
          <td style="width:19%">{{data.nickname||''}}</td>
          <td style="width:12%">民族</td>
          <td style="width:19%">{{data.tbNation&&nationList[data.tbNation - 1]||'-'}}</td>
          <td style="width:12%">现居地</td>
          <td style="width:26%">{{data.tbCurrentPlace||'-'}}</td>
        </tr>
        <tr>
          <td style="width:12%">头像</td>
          <td style="width:19%">
            <img v-if="data.headPortrait" :src="setUrlOss(data.headPortrait)" class="headImg" />
            <div v-else class="headImg background"></div>
          </td>
          <td style="width:12%">文化程度</td>
          <td style="width:19%">{{data.tbEducation&&educationList[data.tbEducation - 1]||'-'}}</td>
          <td style="width:12%" rowspan="4">详细地址</td>
          <td style="width:26%" rowspan="4">
            <div class="address">{{data.tbDetailedAddress||'-'}}</div>
          </td>
        </tr>
        <tr>
          <td style="width:12%">出生年月</td>
          <td style="width:19%">{{data.birthday||'-'}}</td>
          <td style="width:12%">籍贯</td>
          <td style="width:19%">{{data.tbNativePlace||'-'}}</td>
        </tr>
        <tr>
          <td style="width:12%">证件类型</td>
          <td style="width:19%">{{data.tbIdType&&idTypeList[data.tbIdType - 1]||'-'}}</td>
          <td style="width:12%">户籍类型</td>
          <td style="width:19%">{{data.tbDomicileType&&domicileTypeList[data.tbDomicileType - 1]||'-'}}</td>
        </tr>
        <tr>
          <td style="width:12%">证件号码</td>
          <td style="width:19%">{{data.tbIdNumber||'-'}}</td>
          <td style="width:12%">户口所在地</td>
          <td style="width:19%">{{data.tbHukou||'-'}}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import titleComponents from '@/components/mother/title'
export default {
  name: 'baseInfo',
  props: {
    data: {
      type: Object,
      default: () => { }
    }
  },
  data () {
    return {
      idTypeList: ['居民身份证', '护照', '港澳通行证', '其他'],
      educationList: ['文盲或半文盲', '其他'],
      nationList: ['汉族', '其他'],
      domicileTypeList: ['本地', '暂住', '流动'],
      occupationTypeList: ['职员', '医生', '护士', '教师', '工人', '农民', '商人', '公务员', '作家', '其他'],
      nationalityList: ['中国', '其他'],
      show: true
    }
  },
  created () {

  },
  computed: {

  },
  methods: {
  },
  components: {
    titleComponents
  }
}
</script>

<style lang="scss" scoped>
.ui-box-item {
  margin: 20px 24px 0;
  background: rgba(0, 0, 0, 0.02);
  box-sizing: border-box;
  width: calc(100% - 48px);
  .itemInfo-detail {
    border-top: 1px solid #e5e5e5;
    width: 100%;
    padding: 20px;
    box-sizing: border-box;
    .baseInfo-content {
      display: flex;
      align-content: center;
      margin-bottom: 25px;
      .text {
        font-weight: 400;
        font-size: 14px;
        color: #000000;
        line-height: 22px;
        margin-right: 60px;
      }
    }
    .ui-box-table {
      table-layout: fixed;
      text-align: center;
      width: 100%;
      border: 1px solid #d8d8d8;
      border-radius: 6px;
      border-collapse: collapse;
      border-style: hidden;
      box-shadow: 0 0 0 1px #e0e0e0;
      overflow: hidden;
      tr {
        border: 1px solid #e0e0e0;
        height: 54px;
        line-height: 54px;
        th {
          background: #ffffff;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 700;
          color: #000000;
          text-align: center;
          border: 1px solid #e0e0e0;
        }
        td {
          background: #ffffff;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #000000;
          border: 1px solid #e0e0e0;
          .address {
            margin: 0 20px;
            font-weight: 400;
            font-size: 14px;
            color: #000000;
            line-height: 22px;
            font-style: normal;
            word-wrap: break-word;
            overflow-wrap: break-word;
            word-break: break-all;
          }
          .headImg {
            width: 46px;
            height: 46px;
            margin: 0 auto;
            &.background {
              background: #d8d8d8;
            }
          }
        }
      }
    }
  }
}
</style>
     